export default __webpack_public_path__ + "static/media/bg01.409b7d4e.jpg";